import { InjectionToken, inject } from '@angular/core'
import { DOCUMENT } from '@angular/common'

export const WINDOW = new InjectionToken<Window>('Window', {
  providedIn: 'root',
  factory: () => {
    const doc = inject(DOCUMENT)
    if (!doc.defaultView) throw new Error('Window not available')
    return doc.defaultView
  },
})
